import { apiClient } from '@/services/api';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '@/settings/api-settings';
import IExpression from '@/interfaces/expression';

export function getExpressions(): Observable<IExpression[]> {
  return from(apiClient.get(ENDPOINTS.EXPRESSION)).pipe(
    map((r: any) => r.data),
  );
}
export function saveExpression(payload: any): Observable<any> {
  return from(apiClient.post(ENDPOINTS.EXPRESSION, payload)).pipe(
    map((r: any) => r.data),
  );
}
export function updateExpression(payload: any): Observable<any> {
  return from(apiClient.post(ENDPOINTS.EXPRESSION, payload)).pipe(
    map((r: any) => r.data),
  );
}
export function deleteExpression(id: number): Observable<any> {
  return from(apiClient.delete(ENDPOINTS.EXPRESSION, { id })).pipe(
    map((r: any) => r.data),
  );
}
